/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext } from 'react';
import { AppContext } from '@ctsu/loader';
import { toLower, uniq } from 'lodash/fp';
import { k } from '../../../assets/text';
import AppBody from '../AppBody';

const APPNAME = process.env.REACT_APP_NAME;

export default function Permission() {
  const {
    session: { userPermissions },
    application
  } = useContext(AppContext);
  const { appConfig: { UN_AUTHORIZED_USER_MSG_PRIMARY } = {} } =
    application || [];

  let memo = UN_AUTHORIZED_USER_MSG_PRIMARY;
  const userAppNames = uniq(userPermissions.map((a) => a.split('.')[0]));
  const permissions = userAppNames.indexOf(toLower(APPNAME)) > -1;

  if (!permissions) {
    memo = k.ACCESS_DENIED;
  }
  return (
    <AppBody bodyClassNames="align-center">
      <p className="align-center content-page-title">{memo}</p>
      <p>
        {k.NO_ROLE_MESSAGE} {k.CONTACT_HELP_DESK.LINE_ONE}
        <a
          href="mailto:ctsucontact@westat.com?Subject=Access%20Denied"
          className="mx-1"
          target="_top"
        >
          {k.CONTACT_HELP_DESK.LINE_TWO}
        </a>
        {k.CONTACT_HELP_DESK.LINE_THREE}
      </p>
    </AppBody>
  );
}
